/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown, faChevronUp, faFileAlt, faPlusSquare, faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"

import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Collapse, Container, Form, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import dayjs from "dayjs"
import { generatePath, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."

import AlertComponent from "../../../components/AlertComponent"

import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除, 画面ロック開始 } from "../../../globalStore/progressStore"
import {
  TZyomuinKyuyoInfoGetRes,
  TZyomuinKyuyoListGetReq,
  TZyomuinKyuyoZissekiPutReq,
} from "../../../service/driverpayroll/zyomuinKyuyoV2/TZyomuinKyuyo"
import ZyomuinKyuyoService from "../../../service/driverpayroll/zyomuinKyuyoV2/zyomuinKyuyoService"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import Decimal from "decimal.js"
import { saveAs } from "file-saver"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { FunctionContext } from "../../../components/Context"
import { showInfoToast } from "../../../components/CustomToast"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { メニューコード } from "../../../constant/menuCode"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { zyomuinKyuyoActions } from "../../../globalStore/pageStore/zyomuinKyuyoStore/zyomuinKyuyoStore"
import { RootState } from "../../../globalStore/rootreducer"
import BusyoService from "../../../service/master/busyo/busyoService"
import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import commonUtil from "../../../ts/util/commonUtil"
import dateUtil from "../../../ts/util/dateUtil"
import { TWijmoCellTemplateContext, TWijmoComboBox } from "../../../type/wijmoComponents"
import KadoTyoseiRegisterModal from "./KadoTyoseiRegisterModal"

type IGridFields = {
  is手当編集Checked: boolean
}

type T乗務員給与一覧Grid = TZyomuinKyuyoInfoGetRes & IGridFields

const 編集可能CellBindings: (keyof T乗務員給与一覧Grid)[] = ["資格手当", "特別加給", "調整給"]

/**
 * 乗務員給与一覧
 * @returns
 */
const ZyomuinKyuyoV2List = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch: AppDispatch = useDispatch()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // 稼働調整Modal用
  const ref年月 = useRef<string>(eigyobi)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinKyuyoV2List_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<TZyomuinKyuyoInfoGetRes & Partial<IGridFields>>, pageSize: number) =>
    new wjCore.CollectionView(
      [
        ...data.map((d) => ({
          ...d,
          is手当編集Checked: d.is手当編集Checked,
        })),
      ],
      {
        pageSize,

        // TODO:運行月報の値を計算式に反映する必要がある。
        calculatedFields: {
          // sort
          sort_部所コード: (i: T乗務員給与一覧Grid) =>
            commonUtil.createSortString(i.部所コード, VALIDATE_CONSTANT.LENGTH.部所コード),
          sort_社員コード: (i: T乗務員給与一覧Grid) =>
            commonUtil.createSortString(i.社員コード, VALIDATE_CONSTANT.LENGTH.社員コード),
          str勤務時間: (i: T乗務員給与一覧Grid) => dateUtil.toTimeSpanStringHH(i.勤務時間),
          str残業時間: (i: T乗務員給与一覧Grid) => dateUtil.toTimeSpanStringHH(i.残業時間),
          str深夜時間: (i: T乗務員給与一覧Grid) => dateUtil.toTimeSpanStringHH(i.深夜時間),
          str休出時間: (i: T乗務員給与一覧Grid) => dateUtil.toTimeSpanStringHH(i.休出時間),
          支給合計: (i: T乗務員給与一覧Grid) => {
            const c基本給 = new Decimal(i.基本給 ?? 0)
            const c住宅手当 = new Decimal(i.住宅手当 ?? 0)
            const c勤続手当 = new Decimal(i.勤続手当 ?? 0)
            const c永年勤続手当 = new Decimal(i.永年勤続手当 ?? 0)
            const c地域調整金 = new Decimal(i.地域調整金 ?? 0)
            const c稼働割増手当 = new Decimal(i.稼働割増手当 ?? 0)
            const c資格手当 = new Decimal(i.資格手当 ?? 0)
            const c時間外手当 = new Decimal(i.時間外手当 ?? 0)
            const c割増時間外手当 = new Decimal(i.割増時間外手当 ?? 0)
            const c深夜手当 = new Decimal(i.深夜手当 ?? 0)
            const c法定休日手当 = new Decimal(i.法定休日手当 ?? 0)
            const c休日手当 = new Decimal(i.休日手当 ?? 0)
            const c運行調整 = new Decimal(i.運行調整 ?? 0)
            const c稼働手当 = new Decimal(i.稼働手当 ?? 0)
            const c評価手当 = new Decimal(i.評価手当 ?? 0)
            const c特別加給 = new Decimal(i.特別加給 ?? 0)
            const c調整給 = new Decimal(i.調整給 ?? 0)
            const c稼働調整額 = new Decimal(i.稼働調整額 ?? 0)

            return c基本給
              .plus(c住宅手当)
              .plus(c勤続手当)
              .plus(c永年勤続手当)
              .plus(c地域調整金)
              .plus(c稼働割増手当)
              .plus(c資格手当)
              .plus(c時間外手当)
              .plus(c割増時間外手当)
              .plus(c深夜手当)
              .plus(c法定休日手当)
              .plus(c休日手当)
              .plus(c運行調整)
              .plus(c稼働手当)
              .plus(c評価手当)
              .plus(c特別加給)
              .plus(c調整給)
              .plus(c稼働調整額)
              .toNumber()
          },
        },

        sortDescriptions: [
          new wjCore.SortDescription("sort_部所コード", true),
          new wjCore.SortDescription("sort_社員コード", true),
        ],

        // GridFooterからのイベント伝達用
        onPageChanged() {
          if (flexGrid && flexGrid.itemsSource) {
            const pageIndex = flexGrid!.itemsSource!.pageIndex
            setPageNumber(pageIndex)
          }
        },
      },
    )

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TZyomuinKyuyoListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    disPatch(clearAlert()) // アラートを非表示に
    setIsSearched(false)

    let currentSearchCondition: TZyomuinKyuyoListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }

    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(createDisplaySearchCondition(currentSearchCondition))

    try {
      const res = await new ZyomuinKyuyoService().getList(currentSearchCondition)

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
      setIsSearched(true)
      // 稼働調整Modal用にRefに年月を保存
      ref年月.current = currentSearchCondition.年月 ?? eigyobi

      set更新ボタン押下可能フラグ(false)
    } catch (error) {
      dispatch(setAlerts(error))

      setIsSearched(false)
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      flexGrid?.refresh()
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TZyomuinKyuyoListGetReq = queryString.parse(location.search)
    set年月(query.年月)
    set部所コード(query.部所コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TZyomuinKyuyoListGetReq => {
    return {
      年月: 年月 ?? new Date().toISOString(),
      部所コード: 部所コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (searchCondition: TZyomuinKyuyoListGetReq) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")

    const disp部所 = 部所ItemSource?.find((i) => i.部所コード === searchCondition.部所コード)
    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      部所: disp部所 ? `${disp部所.部所コード} ${disp部所.部所略称}` : undefined,
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    let extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      c.allowMerging = true
      c.align = "left"

      // 固定部分
      if (c.binding === "部所略称" || c.binding === "社員コード" || c.binding === "社員氏名") {
        columnHeaders.setCellData(0, index, "乗務員")
        c.align = "left"
      } else if (
        c.binding === "出勤日数" ||
        c.binding === "休出日数" ||
        c.binding === "特休日数" ||
        c.binding === "有休日数" ||
        c.binding === "振替日数" ||
        c.binding === "代休日数" ||
        c.binding === "欠勤日数"
      ) {
        columnHeaders.setCellData(0, index, "就労日数")
        c.align = "right"
      } else if (
        c.binding === "str勤務時間" ||
        c.binding === "str残業時間" ||
        c.binding === "str深夜時間" ||
        c.binding === "str休出時間"
      ) {
        columnHeaders.setCellData(0, index, "就労時間")
        c.align = "right"
      } else if (c.binding === "支給合計") {
        columnHeaders.setCellData(0, index, "支給合計")
        c.align = "right"
      } else if (
        c.binding === "欠勤控除" ||
        c.binding === "通勤費_課税" ||
        c.binding === "通勤費_非課税" ||
        c.binding === "食事手当"
      ) {
        columnHeaders.setCellData(0, index, "控除")
        c.align = "right"
      } else if (
        c.binding === "基本給" ||
        c.binding === "住宅手当" ||
        c.binding === "勤続手当" ||
        c.binding === "永年勤続手当" ||
        c.binding === "地域調整金" ||
        c.binding === "資格手当"
      ) {
        columnHeaders.setCellData(0, index, "基準内賃金")
        c.align = "right"
      } else if (
        c.binding === "時間外手当" ||
        c.binding === "割増時間外手当" ||
        c.binding === "深夜手当" ||
        c.binding === "法定休日手当" ||
        c.binding === "休日手当" ||
        c.binding === "運行調整" ||
        c.binding === "稼働手当" ||
        c.binding === "評価手当" ||
        c.binding === "特別加給" ||
        c.binding === "調整給" ||
        c.binding === "稼働調整額" ||
        c.binding === "稼働割増手当"
      ) {
        columnHeaders.setCellData(0, index, "基準外賃金")
        c.align = "right"
      } else if (c.binding === "is手当編集Checked") {
        const setHeaderText = c.header ?? ""
        columnHeaders.setCellData(0, index, setHeaderText)
        c.align = "center"
      } else {
        const setHeaderText = c.header ?? ""
        columnHeaders.setCellData(0, index, setHeaderText)
      }
      if (c.binding === "稼働手当" || c.binding === "稼働調整額") {
        c.align = "right"
      }
    })

    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      if (
        panel.cellType === wjGrid.CellType.ColumnHeader &&
        (cell.innerHTML === "控除" ||
          cell.innerHTML === "支給明細" ||
          cell.innerHTML === "基準内賃金" ||
          cell.innerHTML === "基準外賃金")
      ) {
        cell.style.textAlign = "center"
      } else if (
        panel.cellType === wjGrid.CellType.ColumnHeader &&
        (cell.innerHTML === "就労日数" || cell.innerHTML === "就労時間")
      ) {
        cell.style.textAlign = "center"
      }
    }

    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  const beginningEdit = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {
    let colBindings = (s.columns[e.col].binding as keyof T乗務員給与一覧Grid) ?? ("" as keyof T乗務員給与一覧Grid)
    let dataItem: T乗務員給与一覧Grid = e.getRow().dataItem
    // 一部手編集可能セル以外は編集不可
    if (
      dataItem.is手当編集Checked &&
      !編集可能CellBindings.includes(colBindings) &&
      colBindings !== "is手当編集Checked"
    ) {
      e.cancel = true
      return
    }
  }

  const pastingCell = beginningEdit

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = async (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {
    let col = s.columns[e.col]

    if (e.cancel === true) {
      return
    }

    switch (col.binding as keyof T乗務員給与一覧Grid) {
      case "資格手当":
        break
      case "is手当編集Checked":
        const dataItems = s.collectionView.sourceCollection as T乗務員給与一覧Grid[]
        // データの全体検索を行い編集する人がいないか確認しフラグをONにする
        set更新ボタン押下可能フラグ(dataItems.some((i) => i.is手当編集Checked))
        break
      default:
        break
    }
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding as keyof T乗務員給与一覧Grid
      const targetRow = e.getRow()
      const dataItem: T乗務員給与一覧Grid = targetRow.dataItem

      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        if (編集可能CellBindings.includes(cellBinding)) {
          wjCore.toggleClass(e.cell, "read-only-cell", !dataItem.is手当編集Checked)
        }
      }
    }
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    try {
      await submitInner()
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  const 稼働調整ModalBeforeSubmit = async () => {
    setIsRestoreSearching(true)
    setIsSearching(true)
    setIs稼働調整後SubmitStart(true)
  }

  const 稼働調整ModalSubmit = async () => {
    // try {
    //   await submitInner()
    // } finally {
    //   setIs稼働調整後SubmitStart(false)
    // }
    try {
      //稼働調整後は稼働調整のみを更新した後検索しなおす
      const service = new ZyomuinKyuyoService()
      let res: TApiResponse<boolean>

      // 稼働調整は部所関係なく登録できるため、部所コードは指定しない
      res = await service.稼働調整後update({
        給与支給年月: preSearchCondition?.年月!,
      })
      disPatch(setAlerts(res))
      if (res) {
        showInfoToast(`稼働調整を反映しました。`)
        // 遷移してきた際のクエリパラメータで検索条件を生成
        // リストア中フラグON
        setIsRestoreSearching(true)
        setIsConfirmModalShow(false)
        // 再検索

        await search(preSearchCondition)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      disPatch(画面ロック解除())
      setIs稼働調整後SubmitStart(false)
    }
  }

  const submitInner = async () => {
    const service = new ZyomuinKyuyoService()
    let res: TApiResponse<boolean>
    try {
      res = await service.create({
        給与支給年月: preSearchCondition?.年月!,
        部所コード: preSearchCondition?.部所コード,
      })
      disPatch(setAlerts(res))
      if (res) {
        showInfoToast(`給与実績の再計算が完了しました。`)
        // 遷移してきた際のクエリパラメータで検索条件を生成
        // リストア中フラグON
        setIsRestoreSearching(true)
        setIsConfirmModalShow(false)
        // 再検索
        search(preSearchCondition).finally(() => {
          disPatch(画面ロック解除())
        })
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  const beforeSelectedSubmit = () => {
    let dataList: Array<TZyomuinKyuyoZissekiPutReq> = []

    // 業務手当作成のため、選択行のみを一覧化する
    gridData.data.sourceCollection
      .filter((d: T乗務員給与一覧Grid) => d.is手当編集Checked)
      .forEach((d: T乗務員給与一覧Grid) => {
        dataList.push({
          更新日時: d.更新日時,
          給与実績ID: d.給与実績ID,
          特別加給: d.特別加給,
          調整給: d.調整給,
          資格手当: d.資格手当,
        })
      })
    setUpdateTargetList([...dataList])
    setIsSelectedConfirmModalShow(true)
  }

  const selectedSubmit = async () => {
    try {
      const service = new ZyomuinKyuyoService()
      let res: TApiResponse<boolean>
      res = await service.put(updateTargetList)
      disPatch(setAlerts(res))
      if (res) {
        // if (true) {
        showInfoToast(`給与実績の更新が完了しました。`)
        // 遷移してきた際のクエリパラメータで検索条件を生成
        // リストア中フラグON
        setIsRestoreSearching(true)
        setIsSelectedConfirmModalShow(false)
        // 再検索
        search(preSearchCondition).finally(() => {
          setUpdateTargetList([])
          disPatch(画面ロック解除())
          set更新ボタン押下可能フラグ(false)
        })
      }
    } catch (error) {
      setIsSelectedConfirmModalShow(false)
      disPatch(setAlerts(error))
    }
  }

  const downloadCsv = async () => {
    const service = new ZyomuinKyuyoService({ responseType: "blob" })

    try {
      const blob = await service.downloadCsv({
        年月: preSearchCondition?.年月!,
      })
      saveAs(blob, `乗務員給与_OBIC連携_${dayjs().format("YYYYMMDDHHmmss")}_v2.csv`)
    } catch (err) {
      disPatch(setAlerts(err))
    } finally {
      setIsDownloadCsvConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [isSearched, setIsSearched] = useState(false) // 検索完了
  const [is稼働調整後SubmitStart, setIs稼働調整後SubmitStart] = useState(false) // 検索完了

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isSelectedConfirmModalShow, setIsSelectedConfirmModalShow] = useState(false)
  const [isKadoTyoseiModalShow, setIsKadoTyoseiModalShow] = useState<boolean>(false)
  const [isDownloadCsvConfirmModalShow, setIsDownloadCsvConfirmModalShow] = useState(false)
  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  const [searchDataInitialized, setSearchDataInitialized] = useState<boolean>(false)

  // モーダル側との検索動作判定用
  const [preSearchCondition, setPreSearchCondition] = useState<TZyomuinKyuyoListGetReq>({} as TZyomuinKyuyoListGetReq)

  // ボタン制御
  const [更新ボタン押下可能フラグ, set更新ボタン押下可能フラグ] = useState(false)

  //#endregion

  //#region [state]
  const [年月, set年月] = useState<string | null>()
  const [updateTargetList, setUpdateTargetList] = useState<TZyomuinKyuyoZissekiPutReq[]>([])

  // combobox
  // 部所
  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<T部所マスタ["部所コード"], T部所マスタ> | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  //#endregion

  //#region [effect]
  // APIからItemSourceを取得
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      setSearchDataInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && searchDataInitialized && 部所ComboBox) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          disPatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        disPatch(画面ロック解除())
      }
    }
  }, [gridInitialized, searchDataInitialized, 部所ComboBox])

  useEffect(() => {
    document.title = `乗務員給与一覧`
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())

    // 年月を初期設定
    set年月(eigyobi)
  }, [])

  useEffect(() => {
    if (!is稼働調整後SubmitStart) return
    稼働調整ModalSubmit()
  }, [is稼働調整後SubmitStart])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">乗務員給与一覧(新)</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card>
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon icon={accordionController ? faChevronDown : faChevronUp} size={"1x"} />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-10rem">
                              <MonthInput
                                autoFocus
                                id="年月"
                                value={年月}
                                setValue={set年月}
                                isRequired={true}
                                placeholder="年月"
                              />
                            </div>

                            <ComboBox.Busyo
                              placeholder="部所"
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              setSelectedValue={set部所コード}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              selectedValue={部所コード}
                              setSelectedItem={set部所}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                          </div>
                        </div>
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            // storeを初期化する
                            disPatch(zyomuinKyuyoActions.init())
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel displaySearchCondition={displaySearchCondition} />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                isShowGridRowPickupButton={false}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                gridProperties={{
                  frozenColumns: 4,
                  isReadOnly: false, // 編集可能
                  beginningEdit,
                  pastingCell,
                  cellEditEnded,
                }}
                headerComponent={
                  <>
                    <Button
                      disabled={!isSearched || 更新ボタン押下可能フラグ}
                      type="submit"
                      variant="waiting"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        beforeSubmit()
                      }}>
                      <FontAwesomeIcon icon={faPlusSquare} />
                      給与計算実績登録・更新
                    </Button>

                    <Button
                      disabled={!isSearched || !更新ボタン押下可能フラグ}
                      variant="waiting"
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        beforeSelectedSubmit()
                      }}>
                      <FontAwesomeIcon icon={faPlusSquare} />
                      選択社員手当更新実行
                    </Button>

                    {/* Excelコピペ貼り付け用Modal呼び出し */}
                    <Button
                      disabled={!isSearched || 更新ボタン押下可能フラグ}
                      className="ms-5"
                      type="submit"
                      variant="primary"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        setIsKadoTyoseiModalShow(true)
                      }}>
                      <FontAwesomeIcon icon={faPlusSquare} />
                      稼働調整 Excel貼り付け
                    </Button>

                    <Button
                      disabled={!isSearched}
                      className="btn-done"
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        setIsDownloadCsvConfirmModalShow(true)
                      }}>
                      <FontAwesomeIcon icon={faFileAlt} />
                      OBC連携CSV作成
                    </Button>

                    <span className="fw-bold">
                      ※ 給与計算実績登録・更新を行う前に運行月報の情報が最新であることを確認してください。
                    </span>
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  allowDragging={false}
                  binding="部所略称"
                  width={140}
                  sortMemberPath="sort_部所コード"
                  header="部所"
                  isReadOnly></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  allowDragging={false}
                  binding="社員コード"
                  width={100}
                  sortMemberPath="sort_社員コード"
                  header="社員番号"
                  isReadOnly></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  allowDragging={false}
                  binding="社員氏名"
                  width={128}
                  header="氏名">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<TZyomuinKyuyoInfoGetRes>) => {
                      return context.item.給与支給年月 && dayjs(context.item.給与支給年月).isValid() ? (
                        <a
                          className="text-center text-primary"
                          target="_blank"
                          rel="noreferrer"
                          href={generatePath(util.getMenuPath(メニューコード.勤怠管理.乗務員出勤簿_v2)[0], {
                            id: context.item.社員ID,
                            date: dayjs(context.item.給与支給年月).format("YYYY-MM-DD"),
                          })}>
                          {context.item.社員氏名}
                        </a>
                      ) : (
                        <>{context.item.社員氏名}</>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  variant="waiting"
                  header="編集"
                  wordWrap={true}
                  dataType={wjCore.DataType.Boolean}
                  allowDragging={false}
                  hasFilter={false}
                  allowSorting={false}
                  isReadOnly={false}
                  binding="is手当編集Checked"
                  allowMerging={true}
                  selectable={false}
                  align="center"
                  width={60}></wjrGrid.FlexGridColumn>
                {/* 就労時間 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="str勤務時間"
                  width={60}
                  isReadOnly
                  header="勤務"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="str残業時間"
                  width={60}
                  header="残業"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="str深夜時間"
                  // format="N2"
                  width={60}
                  header="深夜"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="str休出時間"
                  width={60}
                  header="休出"></wjrGrid.FlexGridColumn>
                {/* 就労日数 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="出勤日数"
                  width={60}
                  format="N1"
                  header="出勤"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="休出日数"
                  width={60}
                  format="N1"
                  header="休出"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="特休日数"
                  width={60}
                  format="N0"
                  header="特休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="有休日数"
                  width={60}
                  format="N1"
                  header="有休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="振替日数"
                  format="N1"
                  width={60}
                  header="振替"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="代休日数"
                  format="N1"
                  width={60}
                  header="代休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="欠勤日数"
                  width={60}
                  format="N1"
                  header="欠勤"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="支給合計"
                  format="N0"
                  dataType={wjCore.DataType.Number}
                  width={100}
                  header="支給合計"></wjrGrid.FlexGridColumn>
                {/* 給与実績 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="基本給"
                  format="N0"
                  width={100}
                  header="基本給"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="住宅手当"
                  format="N0"
                  width={100}
                  header="住宅手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="勤続手当"
                  format="N0"
                  width={100}
                  header="勤続手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="永年勤続手当"
                  format="N0"
                  width={120}
                  header="永年勤続手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="地域調整金"
                  isRequired={false}
                  format="N0"
                  width={100}
                  header="地域調整金"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="資格手当"
                  isRequired={false}
                  format="N0"
                  width={100}
                  header="資格手当"></wjrGrid.FlexGridColumn>
                {/* 基準外賃金 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="稼働割増手当"
                  isRequired={false}
                  format="N0"
                  width={120}
                  header="稼働割増手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="時間外手当"
                  format="N0"
                  width={100}
                  header="時間外手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="割増時間外手当"
                  format="N0"
                  width={100}
                  header="割増時間外"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="深夜手当"
                  format="N0"
                  width={100}
                  header="深夜手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="法定休日手当"
                  format="N0"
                  width={120}
                  header="法定休日手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="休日手当"
                  format="N0"
                  width={100}
                  header="休日手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="運行調整"
                  format="N0"
                  width={100}
                  header="運行調整"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="稼働手当"
                  format="N0"
                  width={100}
                  header="稼働手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="評価手当"
                  format="N0"
                  width={100}
                  header="評価手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="特別加給"
                  format="N0"
                  width={100}
                  header="特別加給"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="調整給"
                  format="N0"
                  width={100}
                  header="調整給"></wjrGrid.FlexGridColumn>
                {/* EXCEL取込 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="稼働調整額"
                  format="N0"
                  width={100}
                  header="稼働調整額"></wjrGrid.FlexGridColumn>

                {/* 控除 */}
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="欠勤控除"
                  format="N0"
                  width={100}
                  header="欠勤控除"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="通勤費_課税"
                  format="N0"
                  width={140}
                  header="通勤費（課）"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="通勤費_非課税"
                  format="N0"
                  width={140}
                  header="通勤費（非）"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  cssClassAll={"read-only-cell"}
                  binding="食事手当"
                  format="N0"
                  width={150}
                  header="食事手当（旅費）"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <FunctionContext.Provider
        value={() => {
          稼働調整ModalBeforeSubmit()
        }}>
        {/* 稼働調整貼り付け */}
        <KadoTyoseiRegisterModal
          isShow={isKadoTyoseiModalShow}
          setIsShow={(v) => {
            setIsKadoTyoseiModalShow(v)
          }}
          年月={ref年月.current ?? eigyobi}
          登録更新="登録"></KadoTyoseiRegisterModal>
      </FunctionContext.Provider>
      {/* 給与計算実行 */}
      <ConfirmModal isShow={isConfirmModalShow} hideHandler={setIsConfirmModalShow} submitHandler={submit}>
        <div>以下の条件で給与実績を計算します。</div>
        <div>既に計算されている乗務員は再計算されます。よろしいですか？</div>
        {displaySearchCondition?.年月 && <div className="mt-1 fw-bold">年月:{displaySearchCondition?.年月}</div>}
        <div className="fw-bold">部所:{displaySearchCondition?.部所 ?? "すべて"}</div>
      </ConfirmModal>
      <ConfirmModal
        isShow={isDownloadCsvConfirmModalShow}
        hideHandler={setIsDownloadCsvConfirmModalShow}
        submitHandler={downloadCsv}>
        <div>OBIC連携用CSVを出力しますか？</div>
        {displaySearchCondition?.年月 && <div className="my-2 fw-bold">年月:{displaySearchCondition?.年月}</div>}
        <div className="text-danger">最後に計算された給与内容で出力されます。</div>
        <div className="text-danger">最新の計算結果で出力する場合、</div>
        <div className="text-danger">給与計算実績登録・更新を行った上で出力を行ってください。</div>
      </ConfirmModal>
      <ConfirmModal
        isShow={isSelectedConfirmModalShow}
        hideHandler={setIsSelectedConfirmModalShow}
        submitHandler={selectedSubmit}>
        <div className="mb-1">以下の乗務員の計算内容を更新します。</div>
        {updateTargetList.map((t) => {
          const 列情報 = gridData.data.sourceCollection.find(
            (i: T乗務員給与一覧Grid) => t.給与実績ID === i.給与実績ID,
          ) as T乗務員給与一覧Grid
          return (
            <div key={列情報?.社員ID}>
              {列情報?.社員コード}:{列情報?.社員氏名}
            </div>
          )
        })}
        <div className="mt-1">よろしいですか？</div>
      </ConfirmModal>
    </Container>
  )
}

export default ZyomuinKyuyoV2List
